import React from 'react';
import './Home5.css';
import Title from '../_title/Title'

import eduzolve_1 from "../../assets/home/_eduzolve-peter-segun.png"
import eduzolve_2 from "../../assets/home/_eduzolve-africa-day.png"
import eduzolve_3 from "../../assets/home/_eduzolve-germany.png"
import eduzolve_4 from "../../assets/home/_eduzolve-tahko-ski.png"


const publicationLists = [
  {
    id: 1,
    image: eduzolve_1,
    title: "From West Africa to Finland for Higher Education and Entrepreneurship: Peter and Olusegun’s Entrepreneurial Journey",
    link: "https://draftprogram.com/en/2024/01/04/from-west-africa-to-finland-for-higher-education-and-entrepreneurship-peter-and-oluseguns-entrepreneurial-journey/",
  },
  {
    id: 2,
    image: eduzolve_2,
    title: "EduZolve at Africa Day 2024 at UEF",
    link: "https://www.uef.fi/en/event/africa-day-2024-at-uef",
  },
  {
    id: 3,
    image: eduzolve_3,
    title: "EduZolve in Germany for Stage Two",
    link: "https://blogs.uef.fi/on-the-move/2024/10/23/a-week-with-uef-startups-in-germany-competitions-building-networks-and-gaining-experience/",
  },
  {
    id: 4,
    image: eduzolve_4,
    title: "EduZolve is among Top 20 most promising start-ups at Tahko Ski Pitch",
    link: "https://www.uef.fi/fi/artikkeli/tahko-ski-lift-pitch-tapahtuman-voitosta-kisaa-kahdeksan-tiimia-ita-suomen-yliopistosta",
  },
];

// Component to display individual publication
const DisplayData = ({ program }) => {
  return (
    <div className="blog">
      <a href={program.link} target="_blank" rel="noopener noreferrer">
        <img src={program.image} alt={program.title} />
        <div className="blog-description">
          <h2>{program.title}</h2>
        </div>
      </a>
    </div>
  );
};

// Main Publications component
const Publications = () => {
  // Duplicate the list for seamless scrolling
  const extendedPublicationLists = [...publicationLists, ...publicationLists];

  return (
    <div className="blogs-container">
      {/* <h1>Scientific Publications</h1> */}
      <Title subTitle="" title="Eduzolve BLOGS: Our Story and Origins"/>
      <div className="blogs">
        <div className="carousel-track">
          {extendedPublicationLists.map((program, index) => (
            <DisplayData key={`${program.id}-${index}`} program={program} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Publications;